import { Component, ElementRef, HostListener, Input, ViewChild, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-visual-panel',
  templateUrl: './visual-panel.component.html',
  styleUrls: ['./visual-panel.component.scss']
})
export class VisualPanelComponent implements AfterViewInit {
  @Input() isMounted = false;
  @ViewChild('parallaxLayer', { static: false }) parallaxLayer!: ElementRef<HTMLDivElement>;
  public currentYear: number;

  orbitParticles = [
    { angle: 0,   color: '#311b92', size: 8,  speed: 11, direction: 'reverse', radius: 170 },
    { angle: 72,  color: '#311b92', size: 6,  speed: 7,  direction: 'normal',  radius: 190 },
    { angle: 144, color: '#311b92', size: 7,  speed: 7,  direction: 'reverse', radius: 85 },
    { angle: 216, color: '#311b92', size: 5,  speed: 15, direction: 'normal',  radius: 95 },
    { angle: 288, color: '#311b92', size: 10, speed: 20, direction: 'reverse', radius: 210 },
  ];

  constructor() {
    this.currentYear = new Date().getFullYear();
  }

  @HostListener('window:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (this.parallaxLayer) {
      const { clientWidth, clientHeight } = document.documentElement;
      const moveX = (event.clientX - clientWidth / 2) / 40;
      const moveY = (event.clientY - clientHeight / 2) / 40;
      const element = this.parallaxLayer.nativeElement;
      element.style.transform = `translate(${moveX}px, ${moveY}px)`;
      element.style.transition = 'transform 0.1s linear';
    }
  }

  calcDelay(speed: number, angle: number): string {
    return `-${(angle / 360) * speed}s`;
  }

  ngAfterViewInit(): void {}
}
